<template>
    <div class="ticket-accept-page">
        <div class="row justify-content-center">
            <div class="col-xl-8 col-lg-10 m-2">
                <div class="card">
                    <div class="card-body">
                        <div class="text-center mb-4">
                            Ticket belongs to: {{ fullName }}
                            <br />
                            Ticket for event : {{ eventName }}
                        </div>

                        <div v-if="!isAccepted">
                            <div class="text-center mb-2">
                                Are you sure you want to accept that ticket?
                            </div>

                            <div class="col-12 d-flex justify-content-around">
                                <button
                                    type="button"
                                    class="btn btn-danger waves-effect waves-light mr-2"
                                    @click="moveToEvents"
                                >
                                    Disagree
                                </button>

                                <button
                                    type="submit"
                                    class="btn btn-success waves-effect waves-light"
                                    @click="agree"
                                >
                                    Agree
                                </button>
                            </div>
                        </div>

                        <div v-else>
                            <div class="text-center mb-2">
                                Success!
                            </div>

                            <div class="col-12 d-flex justify-content-around">
                                <button
                                    type="button"
                                    class="btn btn-success waves-effect waves-light"
                                    @click="moveToEvents"
                                >
                                    Move to events
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    data() {
        return {
            ticket: {},
            code: null,
            isAccepted: false
        };
    },

    computed: {
        fullName() {
            return this.ticket?.user?.fullName;
        },

        eventName() {
            return this.ticket?.event?.name;
        }
    },

    async created() {
        try {
            const { eventId, code } = this.$route.params;

            this.ticket = await this.getTicket({ eventId, code });
            this.code = code;
        } catch (error) {
            console.error(error);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getEvent: 'events/show',
            getTicket: 'events/getTicket',
            acceptTicket: 'events/acceptTicket'
        }),

        async agree() {
            if (!this.ticket?.event?.id || !this.code) {
                this.$toasterError();

                return;
            }

            try {
                const data = {
                    eventId: this.ticket.event.id,
                    code: this.code
                };

                await this.acceptTicket(data);

                this.$toaster('Ticket accepted!');
                this.isAccepted = true;
            } catch (error) {
                console.error(error);

                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data?.message) {
                        this.$toasterError(data.message);

                        return;
                    }
                }

                this.$toasterError();
            }
        },

        moveToEvents() {
            this.$router.push('/events');
        }
    }
};
</script>
